import styled, { css } from 'styled-components';

export const ToastWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    position: fixed;
    flex-direction: column-reverse;
    bottom: 24px;
    overflow: inherit;
    height: auto;
    z-index: ${theme.zIndex.toast};

    @media (max-width: ${theme.breakpoint.sm.maxWidth}) {
      left: 0;
      max-width: calc(100% - ${theme.spacing.km12});
    }
    & > * {
      position: relative;
      @media (max-width: ${theme.breakpoint.sm.maxWidth}) {
        margin: auto ${theme.spacing.km6};
        max-width: content-box;
      }
    }
  `}
`;
